import DataBinder from "../DataBinder.js"
import SwapPage from "../SwapPage.js"
export default class DefaultController {

  constructor(app) {
    this.app = app;
    this.model = {
      socketIOUrl: null,
      onlinePlayerCount: 0,
      isFacebookInstantGame: false,
      userdata: {}
    };
  }
  show(path, model) {

    // //show ad
    // if (typeof Advertisement != 'undefined') { Advertisement.tryShowInterstitialAd(); }
    // //prepare rewarded ad
    


    this.load();

    const swapPage = new SwapPage();
    swapPage.swapPage("OnlineMenu");
  }
  populate() {
    const model = this.model;
    const dataBinder = new DataBinder();
    dataBinder.populate("OnlineMenu", model);
  }
  load() {
    const app = this.app;
    const userdata = app.userdata;
    const config = app.config;
    const serverUrl = userdata.gameServer || userdata.gameServer || config.SocketIOUrl;
    const onlinePlayerCount = null;

    let socketIOUrl = null;

    const isFacebookInstantGame = config.OS === "FBMessenger";


    //set server 
    if (serverUrl) {
      var regex = /(?:http[s]*\:\/\/)*(.*?)\.(?=[^\/]*\..{1,5})/i;
      socketIOUrl = serverUrl.match(regex)[1];
    }


    this.model = {
      socketIOUrl: socketIOUrl,
      onlinePlayerCount: onlinePlayerCount,
      isFacebookInstantGame: isFacebookInstantGame,
      userdata: userdata
    }

    this.populate();

    this.getOnlineStats(serverUrl);
    this.getOnlineUserData(userdata);
  }
  getOnlineStats(serverUrl) {
    //pull online data
    var serverGetDataUrl = serverUrl + '/data' + '?hash_id=' + Math.random();
    fetch(serverGetDataUrl)
      .then(function (response) {
        if (!response.ok) throw Error(response.statusText);
        return response.text();
      })
      .then((data) => {
        this.model.onlinePlayerCount = data;
        this.populate();
      });
  }
  getOnlineUserData(userdata) {
    const id = userdata.id;

    return this.app.gamification.GetUser(id).then((data) => {
      if (data == null) {
        console.log('issue getting data from server, try again later.');
        return;
      }
      userdata.rating = data.Rating;
      userdata.score = data.Score;
      userdata.rank = data.League;
      userdata.leagueRank = data.LeagueRank;
      this.model.userdata = userdata;
      this.populate();

    });
  }

}